<template>
  <div  class="tabs-container ng-scope"  style="padding-bottom:50px;margin-top:18px;">
    <el-form
      :model="user"
      ref="user"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Username
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="name"
                    :rules="[{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    },{ 
                      pattern: /^[a-zA-Z0-9 !#$'()*+,./:;=?@\\^_`~-]{6,50}$/, 
                      message: 'Min. 6 characters' 
                    }]"
                  >
                    <el-input
                      v-model="user.name"
                      :name="'name'"
                      maxLength="50"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.password") }}
                  <span v-if="!$route.query.id" style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="pwd"
                    :rules="[{
                      required: $route.query.id?false:true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    },{ 
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/, 
                      message: 'Please enter a password in the correct format' 
                    }]"
                  >
                    <el-input
                      type="password"
                      v-model.trim="user.pwd"
                      autocomplete="off"
                      show-password
                      :name="'pwd'"
                    />
                    <div class="passwordFormat">{{ $t("message.passwordFormat") }}</div>
                  </el-form-item>

                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.email") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="email"
                    :rules="[{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    },
                    {  
                      type: 'email', 
                      message: 'Please input the correct email address', 
                      trigger: ['blur', 'change'] 
                    }]"
                  >
                    <el-input
                      type="email"
                      v-model.trim="user.email"
                      :name="'email'"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" >
                <label class="col-sm-2 control-label">
                  Role
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-5">
                  <el-form-item
                    prop="roleId"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change'
                    }"
                  >
                    <el-select
                      clearable
                      :disabled="$route.query.id!=undefined"
                      v-model="user.roleId"
                      @change="changeRole"
                      name="role"
                    >
                      <el-option
                        :label="role.name"
                        :value="role.id"
                        :key="role.id"
                        class="ng-binding"
                        v-for="role in roleList"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" >
                <label class="col-sm-2 control-label">
                  District Info
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-5">
                  <el-form-item
                    prop="districtCode"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change'
                    }"
                  >
                    <el-select
                      clearable
                      :disabled="$route.query.id!=undefined"
                      v-model="user.districtCode"
                      name="districtCode"
                    >
                      <el-option
                        v-for="district in showDistrictList"
                        :label="district.districtNameEn"
                        :value="district.districtCode"
                        :key="district.districtCode"
                        class="ng-binding"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.Status") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-5">
                  <el-form-item
                    prop="status"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change'
                    }"
                  >
                    <el-select clearable v-model="user.status" name="status">
                      <el-option
                        v-for="item in statusObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      v-if="
                        (checkPermission('USER_LIST_EDIT') &&
                          $route.query.id) ||
                          (checkPermission('USER_LIST_ADD') &&
                            !$route.query.id)
                      "
                      @click="checkEvent()"
                    >
                      {{ $t("message.Save") }}
                    </el-button>
                    <el-button @click="showWarning()">
                      {{ $t("message.Cancel") }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import sha256 from 'sha256'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      user: {
      },
      roleList: [],
      statusObj: [],
      roleType: "",
      districtList:[]
    };
  },
  created() {
    this.init();
    this.getDistrictList();
  },
  computed:{
    showDistrictList(){
      let districtType
      if([0,1,4,5].includes(this.roleType)) districtType = 1
      else if([2,3,6].includes(this.roleType)) districtType = 2
      else return []
      return this.districtList.filter(i=>{
        return i.type==districtType
      })
    }
  },
  mounted() {},
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.getSystemUserDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        data.data.result.status += "";
        this.$set(this, "user", data.data.result);
      } else {
        let initUser = {
          id: null,
          pwd: "",
          name: "",
          email: "",
          status: "",
          roleId: ""
        };
        this.$set(this, "user", initUser);
      }
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active")
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive")
        }
      ];
      this.getRoleList();
    },
    async getRoleList() {
      let obj = this.getAuthObj();
      obj.systemUserId = this.$route.query.id;
      obj.apiUrl = this.apiConfig.getSystemRoleAllList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "roleList", data.data.result);
    },
    async getDistrictList() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtList", data.data.result);
    },
    changeRole(){
      if(this.user.districtCode) this.user.districtCode = '';
      this.roleList.forEach(item => {
        if(item.id == this.user.roleId){
          this.roleType = item.type;
        }
      })
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
                that.callDelete();
              }
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
              }
            }
          ]
        });
      }
    },
    checkEvent() {
      this.$refs["user"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        obj.user = {}
        var data;
        if (this.$route.query.id) {
          obj.user = {
            id:this.user.id,
            name:this.user.name,
            email:this.user.email,
            roleId:this.user.roleId,
            status:this.user.status,
            districtCode:this.user.districtCode
          }
          if(this.user.pwd){
            obj.user.pwd = sha256(this.user.pwd);
          }
          obj.apiUrl = this.apiConfig.updateSystemUser;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.user = {
            name:this.user.name,
            email:this.user.email,
            roleId:this.user.roleId,
            status:this.user.status,
            districtCode:this.user.districtCode
          }
          if(this.user.pwd){
            obj.user.pwd = sha256(this.user.pwd);
          }
          obj.apiUrl = this.apiConfig.createSystemUser;
          data = await this.$store.dispatch("apiEvent", obj);
        }
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$router.go(-1);
        }
      } catch (err) {
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.ids = [this.$route.query.id];
        obj.apiUrl = this.apiConfig.delSystemUser;
        let data = await this.$store.dispatch("apiEvent", obj);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$router.go(-1);
        }
      } catch (err) {
      }
    }
  }
};
</script>
